import { Flex, Grid, GridItem, Text } from '@chakra-ui/react';
import { OutlineCard } from '@morressier/alembic';
import {
  IRevisionSeverity,
  ISubmissionContext,
  REVISION_SEVERITY_OPTIONS,
  REVISION_SEVERITY_OPTIONS_TO_TEXT
} from '@publishing-engine/domain/models';
import { useEffect } from 'react';
import EditJournalConfigFieldList from './EditJournalConfigFieldList';
import EditJournalConfigMultiSelectField from './EditJournalConfigMultiSelectField';
import { FormProvider, useForm } from 'react-hook-form';

const REVISION_REASON_OPTIONS = REVISION_SEVERITY_OPTIONS.map(value => ({
  value,
  label: REVISION_SEVERITY_OPTIONS_TO_TEXT[value]
}));

export type JournalConfigForm = {
  data?: {};
  config?: {
    editorialWithdrawalOptions?: string[];
    authorWithdrawalOptions?: string[];
    transferOptions?: string[];
    rejectionOptions?: string[];
    revisionSeverityOptions?: IRevisionSeverity[];
    reviewerSearch?: boolean;
    isCoReviewEnabled?: boolean;
    cms?: {
      lexicon?: {
        reviewerActionCard?: {
          createAccount?: boolean;
        };
      };
    };
  };
} & {
  tempOptions?: {
    editorialWithdrawalOptions?: { text: string }[] | undefined;
    authorWithdrawalOptions?: { text: string }[] | undefined;
    transferOptions?: { text: string }[] | undefined;
    rejectionOptions?: { text: string }[] | undefined;
  };
};

const JournalConfig = ({ journal }: { journal: ISubmissionContext }) => {
  const methods = useForm<JournalConfigForm>();

  const { reset } = methods;

  const getOptions = (options: string[]) => {
    return (
      options?.map(option => ({
        text: option
      })) ?? undefined
    );
  };

  useEffect(() => {
    if (journal.config) {
      const journalConfig = journal?.config;

      reset({
        config: {
          reviewerSearch: journalConfig?.reviewerSearch,
          cms: {
            lexicon: {
              reviewerActionCard: {
                createAccount:
                  journalConfig?.cms?.lexicon?.reviewerActionCard?.createAccount
              }
            }
          }
        },
        tempOptions: {
          editorialWithdrawalOptions: getOptions(
            journalConfig?.editorialWithdrawalOptions
          ),
          authorWithdrawalOptions: getOptions(
            journalConfig?.authorWithdrawalOptions
          ),
          transferOptions: getOptions(journalConfig?.transferOptions),
          rejectionOptions: getOptions(journalConfig?.rejectionOptions)
        }
      });
    }
  }, [journal]);

  return (
    <Flex flexDirection={'column'} gap={6}>
      <Flex justifyContent={'space-between'} alignItems={'center'}>
        <Text textStyle={'headingSection'}>
          Reason Configurations
        </Text>
      </Flex>
      <FormProvider {...methods}>
        <OutlineCard borderless paddingX={4} paddingY={6}>
          {/* <Flex flexDirection="column" flex="1" gap={6}> */}
          <Grid templateColumns="repeat(2, 1fr)" gap={6} flex="1">
            <GridItem>
              <EditJournalConfigFieldList
                label="Editorial Withdrawal Reasons"
                data={journal.config.editorialWithdrawalOptions}
                fieldName={'config.editorialWithdrawalOptions'}
                journalId={journal.id}
              />
            </GridItem>
            <GridItem>
              <EditJournalConfigFieldList
                label="Author Withdrawal Reasons"
                data={journal.config.authorWithdrawalOptions}
                fieldName={'config.authorWithdrawalOptions'}
                journalId={journal.id}
              />
            </GridItem>
            <GridItem>
              <EditJournalConfigFieldList
                fieldName={'config.transferOptions'}
                label="Transfer Options"
                data={journal.config.transferOptions}
                journalId={journal.id}
              />
            </GridItem>
            <GridItem>
              <EditJournalConfigFieldList
                fieldName={'config.rejectionOptions'}
                label="Rejection Options"
                data={journal.config.rejectionOptions}
                journalId={journal.id}
              />
            </GridItem>
            <GridItem>
              <EditJournalConfigMultiSelectField
                label="Revision Reasons"
                data={journal.config.revisionSeverityOptions}
                options={REVISION_REASON_OPTIONS}
                fieldName={'config.revisionSeverityOptions'}
                journalId={journal.id}
              />
            </GridItem>
          </Grid>

          {/* <EditReviewerSearchModal journalId={journal.id} /> */}
          {/* </Flex> */}
        </OutlineCard>
      </FormProvider>
    </Flex>
  );
};

export default JournalConfig;
